export default __webpack_public_path__ + "static/media/14473_Atrium_E1_Insel2_1_roteTafel_1000x2430mm_RZ.73be6b67.pdf";